<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
       <!-- <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              The goal of fitness is to take care of the body because it is the only thing we have.
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Fitness Centre</h1>
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h4>WHAT IS A FITNESS APPRAISAL?</h4>
               <ul>
                 <li> A fitness appraisal is a series of measurements designed to give you an estimate of your overall fitness level. </li>
                 <li> Fitness appraisals provide you with valuable information such as your weight, blood pressure, measurements and overall health and fitness. </li>
                 <li> Appraisals will help you to identify problem areas and serve as a starting point for an appropriate exercise program that is tailored to suit your specific needs.</li>
                  <li>Additionally, it is a great benchmark to monitor your progress.</li>
               </ul>




                  <div>


                  </div>


              </div>
              <div>
                <h4>WHAT DOES IT ENTAIL?</h4>
                <ul>
                  <li>Height and Weight</li>
                  <li>Body Composition (Body Mass Index – BMI, Body fat, girth measurements)</li>
                  <li> Programme planning (short and long term goals based on results of appraisal)</li>

                </ul>
               <div>
                 Specific areas you will be measured in include:
                 The appraisal is approximately half hour.
                 If you are experiencing any  form of difficulty, please email the Fitness Centre immediately at <a
                 href="mailto:fitnesscentre@ncu.edu.jm." target="blank">fitnesscentre@ncu.edu.jm</a>

               </div>
              </div>
              <div>
                <div class="uk-child-width-1-2@s uk-child-width-1-2@l " uk-grid>
                  <div>
                    <img class="uk-border-circle" src="../assets/fitness3.jpg" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle" src="../assets/fitness2.jpg" width="200" height="200" alt="Border circle">
                  </div>
                </div>
              </div>
              <div>
                <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>
                  <div>
                    <img class="uk-border-circle" src="../assets/fitness1.jpg" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle" src="../assets/fitness4.jpg" width="200" height="200" alt="Border circle">
                  </div>

                </div>
              </div>
            </div>
            <!--<div class="uk-child-width-1-1@m">
              <hr class="uk-divider-icon">

            </div>-->
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "fitnesscentre"
    }
</script>

<style scoped>

</style>
